import { Controller } from "@hotwired/stimulus"

// Filters the open journal without another request: client names on the
// loaded period, and one specialist column on the team day.
export default class extends Controller {
  static targets = [ "search", "staff" ]

  connect() {
    this.selectedStaffId = ""
  }

  pickDate(event) {
    event.target.form?.requestSubmit()
  }

  filterClients() {
    const query = this.hasSearchTarget ? this.searchTarget.value.trim().toLocaleLowerCase() : ""
    this.element.querySelectorAll("[data-client-name]").forEach((node) => {
      const name = (node.dataset.clientName || "").toLocaleLowerCase()
      node.classList.toggle("is-filtered-out", query !== "" && !name.includes(query))
    })
    this.element.querySelectorAll("[data-schedule-free]").forEach((node) => {
      node.classList.toggle("is-filtered-out", query !== "")
    })
  }

  toggleStaff(event) {
    const id = event.currentTarget.dataset.staffId || ""
    const current = this.hasStaffTarget ? this.staffTarget.value : this.selectedStaffId
    const next = current === id ? "" : id
    this.selectedStaffId = next
    if (this.hasStaffTarget) this.staffTarget.value = next
    this.filterStaff()
  }

  filterStaff() {
    const table = this.element.querySelector(".schedule-board__table")
    if (!table) return
    const selected = this.hasStaffTarget ? this.staffTarget.value : (this.selectedStaffId || "")
    const visible = (node) => selected === "" || (node.dataset.staffId || node.dataset.columnId) === selected
    this.place(table.querySelectorAll(".schedule-board__heading[data-staff-id]"), visible, table)
    this.place(table.querySelectorAll(".schedule-board__cell[data-column-id]"), visible, table)
    this.element.querySelectorAll(".schedule-board__agenda[data-staff-id]").forEach((node) => {
      node.classList.toggle("is-column-hidden", !visible(node))
    })
    this.element.querySelectorAll("[data-staff-chip]").forEach((node) => {
      node.setAttribute("aria-pressed", selected !== "" && node.dataset.staffId === selected ? "true" : "false")
    })
  }

  place(nodes, visible, table) {
    let column = 2
    nodes.forEach((node) => {
      const show = visible(node)
      node.classList.toggle("is-column-hidden", !show)
      if (!show) return
      node.style.gridColumn = String(column)
      column += 1
    })
    table.style.setProperty("--column-count", String(Math.max(column - 2, 1)))
  }
}
